<template>
  <div>
    <h5 class="display-5">Join a class : {{ subject.Name }} </h5>
       <h6>DATE :<strong style="font-size:20px"> {{ subject.DateTime }} </strong></h6>
        <br />
    <h6 class="display-6">
      Please click the "join class" button for the name of the student you wish
      to join. If there is no student name yet, please click the register button
      to enter the student name first
    </h6>
   
    <CCol sm="12" class="mt-5 p-0">
      <div v-if="SuccessMessage == true" class="">
        <CAlert show color="success">You have successfully add package</CAlert>
      </div>
      <CCard>
        <CRow class="ml-3 mr-3">
          <CCol sm="12" class="float-right">
            <br />
            <CButton
              type="button"
              class="btn-success float-right"
              @click="GoToRegister()"
              >Register New Student</CButton
            >
          </CCol>

          <table class="table table-sm-responsive mt-5">
            <thead>
              <th>#</th>
              <th>Student Name</th>
              <th><span class="float-right mr-5"> Action</span></th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in check" v-bind:key="item.Id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span class="text-uppercase"> {{ item.Name }}</span>
                </td>
                <td>
                  <span class="float-right">
                    <a>
                      <div v-if="item.Attendance === true">
                        <CButton type="button" class="btn-success" disabled
                          >Joined Class</CButton
                        >
                      </div>
                      <div v-else>
                        <CButton
                          type="button"
                          class="btn-success"
                          @click="InsertJoinGroup(item)"
                          >Join Class</CButton
                        >
                      </div>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </CRow>
      </CCard>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgCard.png";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      backgroundUrl,
      //users: {},
      user: {},
      childs: [],
      subject: [],
      SuccessMessage: false,
      check: [],
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetPackageName();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetListChild(this.user.id);
            this.GetPackageName(this.user.id);
            this.GetCheckJoinClass(this.user.id);
          }
        });
    },
    GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },
    GetCheckJoinClass(Id) {
      this.$API
        .get(
          this.$CheckJoinClass +
            "?studentId=" +
            this.user.id +
            "&packageId=" +
            Id + 
            "&scheduleId=" +
            this.$route.query.codeId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.check = response.data;
          }
        });
    },
    GetPackageName() {
      this.$API
        .get(this.$GetSubjectPackage + "?id=" + this.$route.query.codeId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subject = response.data;
            this.GetCheckJoinClass(this.subject.Id);
          }
        });
    },
    InsertJoinGroup(item) {

      this.packageId = item.PackageId;
      this.studentId = item.Id;
      const formData = new FormData();

      formData.append("studentId", this.studentId);
      formData.append("packageId", this.packageId);

      return this.$API
        .post(this.$InsertStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.SuccessMessage = true;
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.ErrorMessage = true;
          }
        });
    },
    GoToRegister() {
      this.$router.push("/RegisterStudent?codeId=" + this.$route.query.codeId);
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>

